
// Example helper to send data to your backend
async function saveCustomReportingFields() {

  const kreditorInput = document.querySelector('input[data-field-name="kreditorennummer"]');
  const personenInput = document.querySelector('input[data-field-name="debitorennummer"]');

  const data = {
    kreditorennummer: kreditorInput?.value?.trim(),
    debitorennummer: personenInput?.value?.trim(),
  };

  const personContactId = window.location.pathname.match(/\/edit-person\/(\d+)/)?.[1]
  const companyContactId = window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1]
  const contactId = personContactId || companyContactId

  try {
    const response = await fetch(`${baseApiUrl}/api/impowerX/contacts/${contactId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('auth'))?.token}`
      },
      body: JSON.stringify({ attributes: data }),
    });
    return await response.json();
  } catch (err) {
    console.error('Failed to save custom reporting fields', err);
  }
}

const initializeContactReportingsField = () => {
  const personDiv = document.querySelector('#person')
  const companyDiv = document.querySelector('#info')
  const targetDiv = personDiv || companyDiv

  if (!targetDiv) {
    return false
  }

  // Get current contactId from URL
  const personContactId = window.location.pathname.match(/\/edit-person\/(\d+)/)?.[1]
  const companyContactId = window.location.pathname.match(/\/edit-company\/(\d+)/)?.[1]
  const currentContactId = personContactId || companyContactId
  if (!currentContactId) return false

  // interceptContactSave()

  // Check existing row
  const existingKreditor = targetDiv.querySelector('[data-field-name="kreditorennummer"]')
  const existingPersonen = targetDiv.querySelector('[data-field-name="debitorennummer"]')

  const existingRow = existingKreditor?.closest('.sub-section-content-row') ||
    existingPersonen?.closest('.sub-section-content-row')

  if (existingRow) {
    const hasBothFields = existingKreditor && existingPersonen
    const isSameContact = existingRow?._contactId === currentContactId

    if (hasBothFields && isSameContact) return true

    existingRow.remove()
  }

  const subSectionContent = targetDiv.querySelector('.sub-section-content')
  if (!subSectionContent) return false

  const rows = subSectionContent.querySelectorAll('.sub-section-content-row')
  const lastRow = rows[rows.length - 1]

  if (!lastRow) return false


  const generateResetButton = (field) => {
    const buttonHtml = `
        <span role="img" class="anticon" style="display:inline-flex;align-items:center;color:rgba(0,0,0,.45)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
            <path d="M3 3v5h5"/>
        </svg>
      </span>`
    const resetButtonStyle = `
        font-size: 12px !important;
        height: 24px;
        padding: 0 8px;
        border: none;
        background-color: transparent;
        cursor: pointer;
        line-height: 1;
    `
    const resetButton = document.createElement('button')
    resetButton.innerHTML = buttonHtml
    resetButton.type = 'button'
    resetButton.style.cssText = resetButtonStyle
    resetButton.disabled = true
    resetButton.title = 'Wert zurücksetzen'
    resetButton.hidden = true
    resetButton.classList.add('reset-button')

    const inputEl = field.querySelector('input')
    const syncResetVisibility = () => {
      const input = field.querySelector('input')
      if (!input) return
      const val = (input.value ?? '').trim()
      const show = val !== '' && val !== String(currentContactId)
      resetButton.hidden = !show
    }

    inputEl?.addEventListener('input', syncResetVisibility)
    inputEl?.addEventListener('change', syncResetVisibility)

    resetButton.addEventListener('click', () => {
      resetButton.disabled = true
      field.querySelector('input').value = ''
      syncResetVisibility()
      field.querySelector('input').placeholder = 'Lade ...'
      field.querySelector('input').classList.add('ant-input-disabled')
      field.querySelector('input').disabled = true
      saveCustomReportingFields()
        .then(() => {
          field.querySelector('input').classList.remove('ant-input-disabled')
          field.querySelector('input').disabled = false
          field.querySelector('input').placeholder = currentContactId
        })
        .catch((err) => {
          console.error('Error resetting field:', err)
        })
        .finally(() => {
          resetButton.disabled = false
          syncResetVisibility()
        })
    })
    return resetButton
  }


  // Create row with 2 columns
  const reportingRow = document.createElement('div')
  reportingRow.className = 'sub-section-content-row'
  reportingRow._contactId = currentContactId
  reportingRow.dataset.impowerxContactExtra = 'true'

  reportingRow.innerHTML = `
      <div class="impowerx-kreditor-container"></div>
      <div class="impowerx-personen-container"></div>
    `

  // --- Kreditorennummer ---
  const kreditorContainer = reportingRow.querySelector('.impowerx-kreditor-container')

  const kreditorField = generateInputField({
    id: 'kreditorennummer',
    fieldType: 'TextInput',
    name: 'kreditorennummer',
    label: 'Kreditorennummer',
    placeholder: 'Lade ...',
    value: '',
    isDisabled: true,
  })

  kreditorField.classList.remove('ehv-element')
  kreditorField.dataset.fieldName = 'kreditorennummer'
  kreditorField.querySelector('input')?.setAttribute('data-field-name', 'kreditorennummer')
  const labelColKreditor = kreditorField.querySelector('.ant-col.ant-form-item-label')
  labelColKreditor.style.display = 'flex'
  labelColKreditor.style.justifyContent = 'space-between'
  labelColKreditor.style.alignItems = 'center'
  labelColKreditor.appendChild(generateResetButton(kreditorField))

  kreditorContainer?.replaceWith(kreditorField)

  // --- Debitorennummer ---
  const personenContainer = reportingRow.querySelector('.impowerx-personen-container')

  const personenField = generateInputField({
    id: 'debitorennummer',
    fieldType: 'TextInput',
    name: 'debitorennummer',
    label: 'Debitorennummer',
    placeholder: 'Lade ...',
    value: '',
    isDisabled: true,
  })

  personenField.classList.remove('ehv-element')
  personenField.dataset.fieldName = 'debitorennummer'
  personenField.querySelector('input')?.setAttribute('data-field-name', 'debitorennummer')
  const labelCol = personenField.querySelector('.ant-col.ant-form-item-label')
  labelCol.style.display = 'flex'
  labelCol.style.justifyContent = 'space-between'
  labelCol.style.alignItems = 'center'
  labelCol.appendChild(generateResetButton(personenField))

  personenContainer?.replaceWith(personenField)

  // Insert row
  lastRow.parentNode.insertBefore(reportingRow, lastRow.nextSibling)

  const attributes = ['kreditorennummer', 'debitorennummer']
  fetch(`${baseApiUrl}/api/impowerX/contacts/${currentContactId}?attributes=${attributes.join(',')}`,
    {
      headers: {
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('auth'))?.token}`
      }
    }
  )
    .then(response => {
      if (!response.ok) {
        kreditorField.querySelector('input').placeholder = 'Fehler beim Laden der Kreditorennummer'
        personenField.querySelector('input').placeholder = 'Fehler beim Laden der Debitorennummer'
        kreditorField.querySelector('input').classList.add('ant-input-status-error')
        personenField.querySelector('input').classList.add('ant-input-status-error')

        return false
      }
      return response.json()
    })
    .then(data => {
      kreditorField.querySelector('input').classList.remove('ant-input-disabled')
      personenField.querySelector('input').classList.remove('ant-input-disabled')
      if (!data) return;
      const kreditorValue = data?.attributes?.find(item => item.fieldName === 'kreditorennummer')?.value || ''
      const personenValue = data?.attributes?.find(item => item.fieldName === 'debitorennummer')?.value || ''
      kreditorField.querySelector('input').placeholder = currentContactId
      personenField.querySelector('input').placeholder = currentContactId
      kreditorField.querySelector('input').value = kreditorValue
      personenField.querySelector('input').value = personenValue
      kreditorField.querySelector('input').disabled = false
      personenField.querySelector('input').disabled = false
      kreditorField.querySelector('input').dispatchEvent(new Event('input', { bubbles: true }))
      personenField.querySelector('input').dispatchEvent(new Event('input', { bubbles: true }))
      personenField.querySelector('.reset-button').disabled = false
      kreditorField.querySelector('.reset-button').disabled = false
    }).catch(error => {
      console.error('Error fetching attributes:', error)
    })

  listenToButtonClick('Speichern', saveCustomReportingFields)
  listenToButtonClick('Speichern und Weiter', saveCustomReportingFields)
  listenToButtonClick('Save', saveCustomReportingFields)
  listenToButtonClick('Save and Continue', saveCustomReportingFields)

  return true
}
